import { Component, OnInit } from '@angular/core';
import { OIDCService } from '../services/auth/oidc.service';

@Component({
  selector: 'token-bnp-oidc-helper-login',
  template: `
    <p>
      bnp-oidc-helper-login works !
    </p>
  `,
  styles: []
})
export class BnpOidcHelperLoginComponent implements OnInit {
  constructor( private oidcService:OIDCService) { }

  ngOnInit() {

    window.location.href = this.oidcService.buildRedirectURI();

  }

}
